import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type TransferRefundDetailViewModel from "viewModels/finance/refundApprovals/transferRefunds/transferRefundDetailViewModel";
import OrderSectionView from "../detail/orderSectionView";
import TransferRefundPaymentSectionView from "./transferRefundPaymentSectionView";
import RefundDetailView from "../refundDetailView";
import RefundPaymentSectionView from "../detail/refundPaymentSectionView";
import DomesticRefundDetailViewModel from "viewModels/finance/refundApprovals/transferRefunds/domesticRefunds/domesticRefundDetailViewModel";
import ForeignRefundDetailViewModel from "viewModels/finance/refundApprovals/transferRefunds/foreignRefunds/foreignRefundDetailViewModel";
import SEPARefundDetailViewModel from "viewModels/finance/refundApprovals/transferRefunds/SEPARefunds/SEPARefundDetailViewModel";

const TransferRefundDetailView: ViewComponent<TransferRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <RefundDetailView vm={vm}>
      <Row className="mb-4">
        <Col>
          <OrderSectionView vm={vm} />
        </Col>
      </Row>
      <Row>
        <Col lg={12} xl={6} className="mb-4">
          <TransferRefundPaymentSectionView vm={vm} />
        </Col>
        <Col lg={12} xl={6} className="mb-4">
          <RefundPaymentSectionView vm={vm} />
        </Col>
      </Row>
    </RefundDetailView>
  );
});

registerView(TransferRefundDetailView, DomesticRefundDetailViewModel);
registerView(TransferRefundDetailView, ForeignRefundDetailViewModel);
registerView(TransferRefundDetailView, SEPARefundDetailViewModel);
